import React from "react";
import { useSelector } from "react-redux";
import Unauthenticated from "./Unauthenticated";

const RequireAuth = ({ children }) => {
  const user = useSelector((state) => state.user.user);

  if (!user) {
    return <Unauthenticated />;
  }

  return children;
};

export default RequireAuth;
